import React from 'react'

const Footer = () => {
  return (
    <div>
      <div className="card border-0" style={{width:"100%",background: "#050A30", color:"white",borderRadius:'0'}}>
        <div className="card-body text-center">
          <p>tutorConnect</p>
          <p className='text-light'>For any query email  : ayushprasad2110@gmail.com</p>
        </div>
      </div>
    </div>
  )
}

export default Footer
